import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMetaPixel, fbPageView } from "@/lib/metaPixel";

/**
 * Sits inside <BrowserRouter> so it can observe route changes. On mount it
 * injects the Pixel script once. On every route change it fires a PageView so
 * Ads Manager attributes traffic to the correct page.
 */
export default function MetaPixelListener() {
  const location = useLocation();

  useEffect(() => {
    initMetaPixel();
  }, []);

  useEffect(() => {
    fbPageView();
  }, [location.pathname, location.search]);

  return null;
}
